import { styled, Toolbar, ToolbarProps, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

interface Props extends ToolbarProps {}

export function Footer(props: Props) {
  const { t } = useTranslation();

  return (
    <Styles variant="small" {...props}>
      <Typography variant="small" className="space-between">
        {t("label.appVersion", { version: process.env.REACT_APP_VERSION })}
      </Typography>
      <Typography variant="small" className="space-between">
        {t("label.latestRelease", {
          releaseDate: new Date(
            process.env.REACT_APP_DATE || Date.now()
          ).toLocaleString(),
        })}
      </Typography>
      <Typography variant="small" className="align-right">
        {t("label.poweredByVITO")}
      </Typography>
    </Styles>
  );
}

const Styles = styled(Toolbar)`
  .align-right {
    margin-left: auto;
  }

  .space-between + .space-between {
    margin-left: ${({ theme }) => theme.spacing(4)};
  }
` as unknown as typeof Toolbar;
